import PropTypes from 'prop-types';
import React from 'react';
import isNull from 'lodash/isNull';
import ProgressBar from './progress-bar';
import ErrorModal from './errors/request-error-modal';

export function withViewsState(WrappedComponent, permission) {
	return (props) => {
		if (permission && !props.can(permission)) {
			const menuConfig = props.menuConfig;
			if (menuConfig && menuConfig.availableURIs) {
				const availablePage = menuConfig.availableURIs[0];
				if (availablePage) {
					window.location.href = availablePage;
					return;
				}
			}
		}

		switch (true) {
			case uninitialized(props): return fetchData(props);
			// calling a component as a function does not cover all options for using the component,
			// for example, if the component returns redux connect()
			case hasData(props) || hasError(props): return <WrappedComponent {...props} />;
			case shouldShowProgressBar(props): return renderProgressBar();
			default: throw new Error('Undefined state');
		}
	};
}

export default (hasDataRenderComponent, permission) => props => {
	if (
		permission &&
		(Array.isArray(permission) ? !permission.some(prm => props.can(prm)) : props.can(permission) === false)
	) {
		const menuConfig = props.menuConfig;
		if (menuConfig && menuConfig.availableURIs) {
			const availablePage = menuConfig.availableURIs[0];
			if (availablePage) {
				window.location.href = availablePage;
				return;
			}
		}
	}
	switch (true) {
		case uninitialized(props): return fetchData(props);
		case hasData(props) || hasError(props): return hasDataRenderComponent(props);
		case shouldShowProgressBar(props): return renderProgressBar();
		default: throw new Error('Undefined state');
	}
};

// predicates
const uninitialized = props => !hasError(props) && isNull(props.data) && !shouldShowProgressBar(props);
const hasData = props => !hasError(props) && !isNull(props.data) && !shouldShowProgressBar(props);
const hasError = props => !!props.error && !shouldShowProgressBar(props);
const shouldShowProgressBar = props => props.progressBar;

// views
const fetchData = props => {

	// @todo Think about added possibility run initial config before build redux store
	// or reinitialize redux store use new initial config
	const shouldSetUserTimezone = props.calendarSetUserTimezoneDate;
	if (!shouldSetUserTimezone) {
		props.fetchData(props);
	} else {
		Promise.resolve()
			.then(() => props.calendarSetUserTimezoneDate())
			.then(isUserTimeZoneIsSet => {
				if (!isUserTimeZoneIsSet) return;
				props.fetchData(props);
			});
	}

	return <ProgressBar />;
};

fetchData.propTypes = {
	fetchData: PropTypes.func,
	calendarSetUserTimezoneDate: PropTypes.func
};

const renderError = (props, hasDataRenderComponent) => {
	const shouldMixedErrorToRenderComponent = !isNull(props.data);

	if (shouldMixedErrorToRenderComponent && hasDataRenderComponent) {
		return (
			<div className="mixed-error-to-render">
				<ErrorModal {...props} />
				{ hasDataRenderComponent(props) }
			</div>
		);
	}

	return <ErrorModal {...props} />;
};

renderError.propTypes = {
	data: PropTypes.object
};

const renderProgressBar = () => <ProgressBar />;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/render-views-state.js